import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";

import bgImg from "../images/webbPurp.png";

const TopShadow = styled.div`
  position: fixed;
  width: 100%;
  height: 20px;
  top: 0;
  background-image: linear-gradient(
    0deg,
    rgba(20, 20, 20, 0),
    rgba(20, 20, 20, 0.2) 55%,
    rgba(20, 20, 20, 0.7) 95%
  );
`;

const StyledNavOuter = styled.div`
  background: rgb(177, 74, 237) url('${bgImg}') repeat;  
  padding: 0;
  box-shadow: 0px 3px 8px rgba(30, 30, 30, 0.3);
  border-bottom: 1px solid rgba(240, 240, 240, 1);
  position: relative;

  div.brand {
    a {
      color: rgb(250, 250, 250);
      text-decoration: none;
      font-size: 2rem;
      font-weight: bold;
    }
  }
`;

const StyledNav = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: rgba(72, 13, 114, 0.9);
  border-top: 1px solid rgba(255, 255, 255, 0.25);

  ul {
    display: flex;
    flex-direction: row;
    list-style: none;
    padding: 0;
    margin: 0;

    @media screen and (min-width: 768px) {
      flex-direction: row;
    }
  }
`;

const StyledBrand = styled.div`
  margin: 1rem auto;
  text-align: center;

  a {
    color: rgb(250, 250, 250);
    text-decoration: none;
    font-size: 1.5rem;
    font-weight: bold;

    @media (min-width: 768px) {
      font-size: 2rem;
    }
  }
`;

const StyledCoffee = styled.div`
  margin: 1rem auto;
  text-align: center;

  a {
    color: rgb(250, 250, 250);
    text-decoration: none;
    font-size: 1.5rem;
    font-weight: bold;

    @media (min-width: 768px) {
      font-size: 2rem;
    }
  }
`;

const StyledNavLink = styled.li`
  margin: 0 15px 0 0;
  padding: 0;

  span,
  a {
    color: #fff;
    text-decoration: none;
    display: block;
    padding: 10px;
    text-align: center;

    &.active,
    &:hover {
      background: rgba(250, 250, 250, 0.2);
    }
  }

  span:hover {
    background: none;
  }
`;

const NavLink = ({ to, children }) => (
  <StyledNavLink>
    <Link to={to} activeClassName="active">
      {children}
    </Link>
  </StyledNavLink>
);

const CustomNavbar = ({ pageInfo, brand }) => (
  <StyledNavOuter>
    <StyledBrand>
      <Link to="/">COVID-19 Stats</Link>
    </StyledBrand>
    <StyledCoffee>
      <a
        href="https://ko-fi.com/P5P51LAKV"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          height="36"
          style={{ border: 0, height: 36 }}
          src="https://cdn.ko-fi.com/cdn/kofi1.png?v=2"
          border="0"
          alt="Buy Me a Coffee at ko-fi.com"
        />
      </a>
    </StyledCoffee>
    <StyledNav>
      <ul>
        <NavLink to="/">World Data</NavLink>
        <NavLink to="/new-us">US Data</NavLink>
        <NavLink to="/advanced-states">US Testing Data</NavLink>
      </ul>
    </StyledNav>
    <TopShadow />
  </StyledNavOuter>
);

export default CustomNavbar;
